<template>
    <div class="index">
            <div class="header">
                <div class="header-img">
                    <img src="../assets/imgs/zhedie.png" @click='openOrClose()'>
                    <img src="../assets/imgs/blmesBg.png">
                </div>
                <div style="display:flex">
                    <p style="color:white;margin-right:30px;margin-top: 2px;">{{realName}}</p>
                    <p  @click="exit()" style="color:white;cursor: pointer;margin-top: 2px;">退出</p>
                </div>
            </div>
        <div class="left">
            
            <el-scrollbar style="height:100%">
                <div class="left-box" style="padding-bottom:60px;">
                    <el-menu
                        :default-active="activeDefaults"
                        class="el-menu-vertical-demo"
                        background-color="#545c64"
                        text-color="#fff"
                        menu-trigger="click"
                        :router='true'
                        :unique-opened='true'
                        active-text-color="#ffffff"
                        :collapse="isCollapse">
                      <!-- <el-menu-item  index="/baseData">
                            <i class="self-icon order" ></i>
                            <span> 微瓴号脉</span>
                      </el-menu-item> -->
                      <el-submenu v-for="item in adminList" :key="item.id" :index='item.name'>
                        <template slot="title">
                            <i class="self-icon" :class='item.iconClass' v-if='item.iconClass'></i>
                            <span>{{item.name}}</span>
                        </template>
                        <el-menu-item :index="subItem.url" v-for="subItem in item.children" :key="subItem.id">
                            <i class="self-icon" :class='subItem.iconClass' v-if='subItem.iconClass'></i>
                            <span>{{subItem.name}}</span>
                        </el-menu-item>
                     </el-submenu>
                  </el-menu>
                </div>
            </el-scrollbar>
        </div>
        <div class="right" :class='ifshow==true?"rightList":"rightList1"' id="main-content-right">
            <div  :class="routerName=='result'||routerName=='report'||routerName=='baseMsg'||routerName=='freezing'||routerName=='fucs'||routerName=='auto'||routerName=='opera'||routerName=='example'||routerName=='energy'?'paddingTopIndex1':routerName=='horizontalCompar'?'paddingTopIndex2':'paddingTopIndex'">
                <router-view></router-view>
            </div>

        </div>
    </div>
</template>
<script>
export default{
    data(){
        return{
            adminList:[],
            activeDefaults:this.$route.path,
            adminMsg:{
                headImage:''
            },
            ifshow:true,
            headImage:'',
            realName:'',
            isCollapse: false,
            routerName:'',

        }
    },
    mounted(){
        var vm=this;
        vm.activeDefaults=this.$route.path
        vm.routerName=this.$route.name
        vm.$http.get('/api/console/getUserInfo')
        .then(function(response){
            if(response.data.nodes){
                vm.adminList=response.data.nodes
            }else{
                vm.adminList=[]
            }
           vm.headImage=response.data.headImage
           vm.realName=response.data.username
            
            
        })
    },
    methods:{
        openOrClose:function(){
            this.ifshow=!this.ifshow
            this.isCollapse=!this.isCollapse
            localStorage.setItem('isCollapse',this.isCollapse)
        },
        exit:function(){
                var vm=this;
                this.$confirm('是否退出', '提示信息', {
                    confirmButtonText: '确定',
                }).then(()=>{
                    vm.$http.get('/api/logout')
                        .then(function(response){
                            if(response.code==0){
                                vm.$router.push({path:'/login'})
                            }
                        })
                }).catch((action)=>{

                })
                    
                
        },
    },
    watch:{
        '$route':function(to,from){
            var doms=document.getElementById('main-content-right')
            doms.scrollTop=0
            this.routerName=to.name
            // console.log(11,to)
        }
    }
}
</script>
<style lang="less" scoped='scoped'>
    .index{
        .paddingTopIndex{
            padding-top:56px
        }
        .paddingTopIndex1{
             padding-top:0px
        }
        .paddingTopIndex2{
            padding: 0;
            // min-height: 100%;
             padding-top:56px;
            background: white;
        }
        .header{
                position: fixed;
                z-index: 1000;
                background: white;
                top: 0;
                left:0;
                right: 0;
                padding: 14px 32px 13px 25px;
                display: flex;
                justify-content: space-between;
                background:black;
                .header-img{
                    width: 14%;
                    -webkit-box-sizing: border-box;
                    box-sizing: border-box;
                    /* background: #222632; */
                    position: relative;
                    /* height: 48px; */
                    z-index: 101;
                    img:last-child{
                        margin-left:28px;
                        position: relative;
                        top:4px;
                    }
                }
                .home-time{
                    display: flex;
                    >p{
                        font-size: 21px;
                        line-height: 33px;
                    }
                    .openOrClose{
                        margin-left: -4px;
                        margin-right: 10px;
                        vertical-align: middle;
                        position: relative;
                        top: 2px;
                        cursor: pointer;
                    }
                }
                .home-person{
                    display: flex;
                    img:first-child{
                        width: 34px;
                        height: 34px;
                        border-radius: 50%;
                    }
                    .exit{
                        height: 17px;
                        width: 17px;
                        position: relative;
                        top: 8px;
                        margin-left: 20px;
                        cursor: pointer;
                    }
                    p{
                        line-height: 33px;
                        margin-left: 10px;
                    }
                }
            }
        .left{
            width: 13%;
            text-align: left;
            background: rgb(84, 92, 100);
            position: fixed;
            left: 0;
            z-index: 10;
            height: 100%;
            -webkit-box-sizing: border-box;
            box-sizing: border-box;
            padding-bottom: 62px;
            z-index: 10;
            margin-top:48px;
            
        }
        .right{
            left: 0;
            height: 100%;
            position: fixed;
            z-index: 100;
            right: 0;
            bottom: 0;
            top: 0;
            background: #edf1f2;
            overflow: auto;
            z-index: 100;
            
        }
        .rightList{
            transition: all 1s;
            left: 13% !important;
        } 

        .rightList1{
            transition: all 1s;
            left: 60px !important;
        } 
        .rightList .header{
            transition: left 1s;
            left: 0;
            z-index: 1000
        } 
        .rightList1 .header{
            transition: left 1s;
            left: 0;
            z-index: 1000
        }
    }
</style>


// WEBPACK FOOTER //
// src/views/index.vue